/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon64Regular = forwardRef('ArrowAUpLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M10 43.5a1.5 1.5 0 0 0 3 0v-26c0-.695.157-1.353.439-1.94l36 36a1.5 1.5 0 0 0 2.122-2.12L15.56 13.438A4.482 4.482 0 0 1 17.5 13h26a1.5 1.5 0 0 0 0-3h-26a7.5 7.5 0 0 0-7.5 7.5v26Z" })));
});
